"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a;
    return (0, styles_1.createStyles)({
        button: (_a = {
                boxShadow: "none",
                margin: "10px"
            },
            _a[theme.breakpoints.down("sm")] = {
                width: "100%",
            },
            _a),
    });
});
function Buttons(props) {
    var classes = useStyles({});
    return (React.createElement(core_1.Button, { className: classes.button, variant: props.variant, color: props.color, disabled: props.disabled, onClick: props.onClick, href: props.href, type: props.type, startIcon: props.startIcon, endIcon: props.endIcon }, props.children));
}
exports.default = Buttons;
//# sourceMappingURL=Buttons.js.map